// extracted by mini-css-extract-plugin
export default {"contractCardsHolder":"styles_contractCardsHolder__6ulue"};